import { Box, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import {
  billedHoursVariantLabels,
  hierarchyTableColors,
  hierarchyTableLayout,
} from "../../Constants/constants";
import { hierarchyTableStyles } from "../../Styles/hierarchyTableStyles";
import type { BilledHoursVariant, HierarchyTableHeaderProps } from "../../Types/types";
import { buildPeriodLabelsFromDateRange } from "./utils";

const BilledHoursSubHeaders = () => (
  <>
    {(Object.keys(billedHoursVariantLabels) as BilledHoursVariant[]).map(
      (variant) => (
        <TableCell
          key={variant}
          sx={hierarchyTableStyles.billedHoursSubHeader(variant)}
        >
          {billedHoursVariantLabels[variant]}
        </TableCell>
      ),
    )}
  </>
);

export const HierarchyTableHeader = ({
  dateStart,
  dateEnd,
}: HierarchyTableHeaderProps) => {
  const revenueColWidth = hierarchyTableLayout.revenueColWidth;
  const {
    revenueCm1Period,
    revenuePeriod,
    gmPeriod,
    billedHoursCm1Period,
    billedHoursPeriod,
  } = buildPeriodLabelsFromDateRange(dateStart, dateEnd);

  return (
    <TableHead>
      <TableRow>
        <TableCell
          rowSpan={2}
          sx={hierarchyTableStyles.headerCell({
            borderWidth: hierarchyTableLayout.borderDefault,
            noBorderTop: true,
            noBorderLeft: true,
            noBorderBottom: true,
            sticky: true,
            align: "left",
            width: hierarchyTableLayout.hierarchyColWidth,
            borderRadius: `${hierarchyTableLayout.borderRadiusLg} 0 0 0`,
          })}
        >
          Org. Hierarchy
        </TableCell>
        <TableCell
          rowSpan={2}
          sx={hierarchyTableStyles.headerCell({
            noBorderTop: true,
            noBorderLeft: true,
            noBorderBottom: true,
            noBorderRight: true,
            align: "right",
            width: revenueColWidth,
          })}
        >
          <Box>
            <Typography component="span" sx={hierarchyTableStyles.headerTitle}>
              Revenue (CM-1)*
            </Typography>
            <Typography
              component="span"
              sx={hierarchyTableStyles.headerSubtext}
            >
              {revenueCm1Period}
            </Typography>
          </Box>
        </TableCell>
        <TableCell
          rowSpan={2}
          sx={hierarchyTableStyles.headerCell({
            noBorderTop: true,
            noBorderLeft: true,
            noBorderBottom: true,
            noBorderRight: true,
            align: "right",
            width: revenueColWidth,
          })}
        >
          <Box>
            <Typography component="span" sx={hierarchyTableStyles.headerTitle}>
              Revenue
            </Typography>
            <Typography
              component="span"
              sx={hierarchyTableStyles.headerSubtext}
            >
              {revenuePeriod}
            </Typography>
          </Box>
        </TableCell>
        <TableCell
          rowSpan={2}
          sx={hierarchyTableStyles.headerCell({
            noBorderTop: true,
            noBorderLeft: true,
            noBorderBottom: true,
            align: "right",
            width: revenueColWidth,
          })}
        >
          <Box>
            <Typography component="span" sx={hierarchyTableStyles.headerTitle}>
              GM%
            </Typography>
            <Typography
              component="span"
              sx={hierarchyTableStyles.headerSubtext}
            >
              {gmPeriod}
            </Typography>
          </Box>
        </TableCell>
        <TableCell
          colSpan={3}
          sx={hierarchyTableStyles.headerCell({
            bg: hierarchyTableColors.billedHoursHeaderBg,
            align: "center",
            noBorderTop: true,
            noBorderLeft: true,
            noBorderBottom: true,
            height: hierarchyTableLayout.headerFirstRowHeight,
          })}
        >
          <Typography sx={hierarchyTableStyles.billedHoursHeaderTitle}>
            Billed Hours (CM-1)
          </Typography>
          <Typography sx={hierarchyTableStyles.billedHoursSubtext}>
            {billedHoursCm1Period}
          </Typography>
        </TableCell>
        <TableCell
          colSpan={3}
          sx={hierarchyTableStyles.headerCell({
            bg: hierarchyTableColors.billedHoursPeriodHeaderBg,
            align: "center",
            noBorderTop: true,
            noBorderLeft: true,
            noBorderBottom: true,
            borderRadius: `0 ${hierarchyTableLayout.borderRadiusLg} 0 0`,
            height: hierarchyTableLayout.headerFirstRowHeight,
          })}
        >
          <Typography sx={hierarchyTableStyles.billedHoursHeaderTitle}>
            Billed Hours (CM-1)
          </Typography>
          <Typography sx={hierarchyTableStyles.billedHoursSubtext}>
            {billedHoursPeriod}
          </Typography>
        </TableCell>
      </TableRow>
      <TableRow>
        <BilledHoursSubHeaders />
        <BilledHoursSubHeaders />
      </TableRow>
    </TableHead>
  );
};
